// React Thirty Party Library
import { useDispatch } from "react-redux";

// Constants Library
import { TEMPLATE, ROOT_CONSTANT } from "../../../../../../constants";

// Components Library
import {
  ButtonModal,
  BtnSubmit,
  TablePagination,
} from "../../../../../../components";

// Handler Librarys

// Redux Actions

import * as REDUX_ACTION from "../../../../../../services/redux/actions";

// Styles Library
import classes from "../../../../../../pages/index.module.css";

const { icon_filter } = ROOT_CONSTANT.IMG.ICON;
const { icon_bank_rhb } = ROOT_CONSTANT.IMG.ICON.BANK;
const { MODAL_ACTION } = TEMPLATE.MODAL;

const SearchPayroll = (props) => {
  const {
    setIsModalOpen,
    pageSize,
    setPageSize,
    current,
    setCurrent,
    tabKey,
    handlePaginatedDataChange,
    filteredDataCount,
    data,
    user,
    selectedRow,
    selectedRowKeys,
    messageApi,
    setIsClicked
  } = props;

  const dispatch = useDispatch();

  const bulkDisbursed = () => {
    messageApi.open({
      type: "loading",
      content: "Bulk disbursed...",
      duration: 0,
    });

    dispatch(
      REDUX_ACTION.v1_payroll.bulk_disbursed_request(
        { prids: selectedRowKeys, updatedBy: user.memid },
        () => {
          messageApi.destroy();
          setIsClicked(true)
        }
      )
    );
  };

  const bulkRevertProcessing = () => {
    messageApi.open({
      type: "loading",
      content: "Bulk revert for processing...",
      duration: 0,
    });

    dispatch(
      REDUX_ACTION.v1_payroll.bulk_revert_processing_request(
        { prids: selectedRowKeys, updatedBy: user.memid },
        () => {
          messageApi.destroy();
          setIsClicked(true)
        }
      )
    );
  };

  const generateRHB = () => {
    messageApi.open({
      type: "loading",
      content: "Generating RHB File...",
      duration: 0,
    });

    const rhbData = selectedRow.filter((d) => d.status === 1);

    dispatch(
      REDUX_ACTION.v1_payroll.generate_rhb_file_request(
        { payrolls: rhbData, createdBy: user.memid },
        () => {
          messageApi.destroy();
          setIsClicked(true)
        }
      )
    );
  };

  return (
    <>
      <div className={classes.headerPage}>
        <div className={classes.headerWrap}>
          <div className={classes.headerSubStart}>
            <BtnSubmit
              display="inline-block"
              text="Filter"
              bgColor="transparent"
              color="black"
              padding="9px 18px"
              marginTop="2px"
              fontWeight="700"
              border="1px solid #DDDDDD"
              outline="#DDDDDD"
              onClick={() => setIsModalOpen(true)}
              showIcon={true}
              icon={icon_filter}
              icon_alt={"filter"}
            />
          </div>
          <TablePagination
            tabKey={tabKey}
            data={data}
            filteredDataCount={filteredDataCount}
            onPaginatedDataChange={handlePaginatedDataChange}
            pageSize={pageSize}
            setPageSize={setPageSize}
            current={current}
            setCurrent={setCurrent}
          />
        </div>

        {user.uroleid === "A" && (
          <div className={classes.headerSubEnd}>
            <ButtonModal
              setmodal={MODAL_ACTION.generate_rhb_payment}
              style={{
                height: "46px",
                marginRight: "5px",
                border: "1px solid #0E2483",
                color: "#0E2483",
              }}
              onClick={generateRHB}
              data={selectedRow}
              disabled={selectedRow.length === 0}
            >
              <img src={icon_bank_rhb} alt="bank rhb" />
              &nbsp; Generate RHB payment file
            </ButtonModal>
            <ButtonModal
              setmodal={
                MODAL_ACTION.confirmation_bulk_revert_for_processing_payroll
              }
              style={{
                height: "46px",
                marginRight: "5px",
                backgroundColor: "#0E2483",
                padding: "9px 18px",
                border: "1px solid #0E2483",
                color: "white",
                outline: "#0E2483",
              }}
              onClick={() => bulkRevertProcessing()}
              data={selectedRow}
              disabled={selectedRow.length === 0}
            >
              Bulk revert for processing
            </ButtonModal>
            <ButtonModal
              setmodal={
                MODAL_ACTION.confirmation_bulk_mark_as_disbursed_payroll
              }
              style={{
                height: "46px",
                marginRight: "5px",
                backgroundColor: "#0E2483",
                padding: "9px 18px",
                border: "1px solid #0E2483",
                color: "white",
                outline: "#0E2483",
              }}
              onClick={() => bulkDisbursed()}
              data={selectedRow}
              disabled={selectedRow.length === 0}
            >
              Bulk disbursed
            </ButtonModal>
          </div>
        )}
      </div>
    </>
  );
};

export default SearchPayroll;